'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["url", "title", "width", "height", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EmbeddedVideo = function EmbeddedVideo(_ref) {
  var url = _ref.url,
    title = _ref.title,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-testid": "embed-video-container",
    className: "ratio ".concat(className),
    children: /*#__PURE__*/jsxRuntime.jsx("iframe", _objectSpread({
      "data-testid": "embed-video-iframe",
      className: "d-block",
      src: url,
      title: title,
      width: width,
      height: height,
      loading: "lazy"
    }, props))
  });
};
EmbeddedVideo.propTypes = {
  url: PropTypes__default.default.string.isRequired,
  title: PropTypes__default.default.string.isRequired,
  width: PropTypes__default.default.string,
  height: PropTypes__default.default.string,
  className: PropTypes__default.default.string
};
EmbeddedVideo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmbeddedVideo",
  "props": {
    "width": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "url": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "title": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var EmbeddedVideo$1 = EmbeddedVideo;

exports.default = EmbeddedVideo$1;
//# sourceMappingURL=EmbeddedVideo.js.map
